export const AT_DEFAULT_CATEGORIES = [
    // --- Betriebseinnahmen ----------------------------------------------------
    {
        code: '4000',
        name: 'Erlöse Inland 20 %',
        direction: 'income',
        e1aKz: '9040',
        defaultTaxCode: 'at-20',
    },
    {
        code: '4010',
        name: 'Erlöse Inland ermäßigt',
        direction: 'income',
        e1aKz: '9040',
        defaultTaxCode: 'at-10',
    },
    {
        code: '4020',
        name: 'Erlöse EU B2B (Reverse Charge)',
        direction: 'income',
        e1aKz: '9040',
        defaultTaxCode: 'eu-service-b2b',
        description: 'Sonstige Leistungen an Unternehmer im EU-Ausland. Gehen in die ZM.',
    },
    {
        code: '4025',
        name: 'Innergemeinschaftliche Lieferungen',
        direction: 'income',
        e1aKz: '9040',
        defaultTaxCode: 'eu-supply-goods',
    },
    {
        code: '4030',
        name: 'Erlöse Drittland',
        direction: 'income',
        e1aKz: '9040',
        defaultTaxCode: 'third-country-service',
    },
    {
        code: '4040',
        name: 'Erlöse Kleinunternehmer',
        direction: 'income',
        e1aKz: '9040',
        defaultTaxCode: 'at-kleinunternehmer',
    },
    {
        code: '4090',
        name: 'Erlöse laut Mitteilung § 109a',
        direction: 'income',
        e1aKz: '9050',
        defaultTaxCode: 'at-20',
        description: 'Honorare, über die der Auftraggeber eine Mitteilung an das Finanzamt schickt.',
    },
    {
        code: '4600',
        name: 'Erlöse aus Anlagenverkauf',
        direction: 'income',
        e1aKz: '9060',
        defaultTaxCode: 'at-20',
    },
    {
        code: '4900',
        name: 'Sonstige Erträge',
        direction: 'income',
        e1aKz: '9090',
        defaultTaxCode: 'sales-no-vat',
    },
    {
        code: '4950',
        name: 'Zinserträge',
        direction: 'income',
        e1aKz: '9090',
        defaultTaxCode: 'sales-no-vat',
    },
    // --- Betriebsausgaben -----------------------------------------------------
    {
        code: '5000',
        name: 'Wareneinkauf, Material',
        direction: 'expense',
        e1aKz: '9100',
        defaultTaxCode: 'vst-20',
    },
    {
        code: '5700',
        name: 'Fremdleistungen, Subunternehmer',
        direction: 'expense',
        e1aKz: '9110',
        defaultTaxCode: 'vst-20',
    },
    {
        code: '6000',
        name: 'Personalaufwand',
        direction: 'expense',
        e1aKz: '9120',
        defaultTaxCode: 'vst-0',
    },
    {
        code: '7000',
        name: 'Abschreibung Anlagevermögen (AfA)',
        direction: 'expense',
        e1aKz: '9130',
        defaultTaxCode: 'vst-0',
        description: 'Wird automatisch aus dem Anlagenverzeichnis gebucht.',
    },
    {
        code: '7010',
        name: 'Geringwertige Wirtschaftsgüter',
        direction: 'expense',
        e1aKz: '9130',
        defaultTaxCode: 'vst-20',
        capitalisable: true,
        description: 'Sofortabschreibung bis 1.000 Euro netto (§ 13 EStG).',
    },
    {
        code: '7020',
        name: 'Degressive Abschreibung',
        direction: 'expense',
        e1aKz: '9134',
        defaultTaxCode: 'vst-0',
    },
    {
        code: '7030',
        name: 'Beschleunigte Gebäudeabschreibung',
        direction: 'expense',
        e1aKz: '9135',
        defaultTaxCode: 'vst-0',
    },
    {
        code: '7200',
        name: 'Instandhaltung Gebäude',
        direction: 'expense',
        e1aKz: '9150',
        defaultTaxCode: 'vst-20',
    },
    {
        code: '7340',
        name: 'Reisekosten, Diäten, Kilometergeld',
        direction: 'expense',
        e1aKz: '9160',
        defaultTaxCode: 'vst-0',
    },
    {
        code: '7345',
        name: 'Öffi-Ticket (50 % Pauschale)',
        direction: 'expense',
        e1aKz: '9165',
        defaultTaxCode: 'vst-10',
        deductibleRate: 50,
    },
    {
        code: '7320',
        name: 'Kfz-Kosten (Treibstoff, Maut, Parken)',
        direction: 'expense',
        e1aKz: '9170',
        defaultTaxCode: 'vst-none',
        vehicleCost: 'value_independent',
        description: 'Für PKW besteht grundsätzlich kein Vorsteuerabzug (§ 12 Abs 2 Z 2 lit b UStG). ' +
            'Diese Kosten hängen an der Fahrleistung, die Angemessenheitsgrenze kürzt sie nicht.',
    },
    {
        code: '7325',
        name: 'Kfz-Versicherung, Service und Reparatur',
        direction: 'expense',
        e1aKz: '9170',
        defaultTaxCode: 'vst-none',
        vehicleCost: 'value_dependent',
        description: 'Wertabhängige Kfz-Kosten. Übersteigen die Anschaffungskosten die Angemessenheitsgrenze, ' +
            'kürzt § 20 Abs 1 Z 2 lit b EStG diese Ausgaben im selben Verhältnis.',
    },
    {
        code: '7400',
        name: 'Miete und Pacht',
        direction: 'expense',
        e1aKz: '9180',
        defaultTaxCode: 'vst-20',
    },
    {
        code: '7410',
        name: 'Leasing',
        direction: 'expense',
        e1aKz: '9180',
        defaultTaxCode: 'vst-20',
    },
    {
        code: '7415',
        name: 'Kfz-Leasing',
        direction: 'expense',
        e1aKz: '9180',
        defaultTaxCode: 'vst-none',
        vehicleCost: 'value_dependent',
        description: 'Beim PKW gilt für die Leasingrate dieselbe Angemessenheitsgrenze wie beim Kauf; ' +
            'ein Vorsteuerabzug steht nur für begünstigte Fahrzeuge zu.',
    },
    {
        code: '7540',
        name: 'Provisionen und Lizenzgebühren',
        direction: 'expense',
        e1aKz: '9190',
        defaultTaxCode: 'vst-20',
    },
    {
        code: '7650',
        name: 'Werbung und Marketing',
        direction: 'expense',
        e1aKz: '9200',
        defaultTaxCode: 'vst-20',
    },
    {
        code: '7680',
        name: 'Bewirtung (50 % abzugsfähig)',
        direction: 'expense',
        e1aKz: '9200',
        defaultTaxCode: 'vst-20',
        deductibleRate: 50,
        description: 'Geschäftsessen mit Werbezweck, § 20 Abs 1 Z 3 EStG.',
    },
    {
        code: '7820',
        name: 'Buchwert abgegangener Anlagen',
        direction: 'expense',
        e1aKz: '9210',
        defaultTaxCode: 'vst-0',
    },
    {
        code: '7275',
        name: 'Arbeitszimmer im Wohnungsverband',
        direction: 'expense',
        e1aKz: '9275',
        defaultTaxCode: 'vst-none',
    },
    {
        code: '7215',
        name: 'Arbeitsplatzpauschale klein (300 Euro)',
        direction: 'expense',
        e1aKz: '9215',
        defaultTaxCode: 'vst-0',
    },
    {
        code: '7216',
        name: 'Ergonomisches Mobiliar',
        direction: 'expense',
        e1aKz: '9216',
        defaultTaxCode: 'vst-20',
        capitalisable: true,
    },
    {
        code: '7217',
        name: 'Arbeitsplatzpauschale groß (1.200 Euro)',
        direction: 'expense',
        e1aKz: '9217',
        defaultTaxCode: 'vst-0',
    },
    {
        code: '8280',
        name: 'Zinsen und Bankspesen',
        direction: 'expense',
        e1aKz: '9220',
        defaultTaxCode: 'vst-0',
    },
    {
        code: '7750',
        name: 'SVS-Beiträge (Sozialversicherung)',
        direction: 'expense',
        e1aKz: '9225',
        defaultTaxCode: 'vst-0',
        description: 'Absetzbar im Jahr der Zahlung.',
    },
    {
        code: '7760',
        name: 'Spenden an begünstigte Einrichtungen',
        direction: 'expense',
        e1aKz: '9244',
        defaultTaxCode: 'vst-0',
    },
    // Sammelposten — alle auf E1a-Kennzahl 9230.
    {
        code: '7300',
        name: 'Telefon und Internet',
        direction: 'expense',
        e1aKz: '9230',
        defaultTaxCode: 'vst-20',
        privateShareDefault: 30,
        description: 'Privatanteil ist zu schätzen und wird automatisch ausgeschieden.',
    },
    {
        code: '7310',
        name: 'IT-Kosten, Software, Hosting, Cloud',
        direction: 'expense',
        e1aKz: '9230',
        defaultTaxCode: 'vst-20',
        // Ein Hosting-Abo ist Aufwand, eine gekaufte Lizenz ein immaterielles
        // Wirtschaftsgut — hier lohnt der Hinweis.
        capitalisable: true,
    },
    {
        code: '7600',
        name: 'Büromaterial und Drucksorten',
        direction: 'expense',
        e1aKz: '9230',
        defaultTaxCode: 'vst-20',
        capitalisable: true,
    },
    {
        code: '7610',
        name: 'Fachliteratur und Zeitschriften',
        direction: 'expense',
        e1aKz: '9230',
        defaultTaxCode: 'vst-10',
    },
    {
        code: '7620',
        name: 'Fortbildung und Seminare',
        direction: 'expense',
        e1aKz: '9230',
        defaultTaxCode: 'vst-20',
    },
    {
        code: '7700',
        name: 'Rechts-, Beratungs- und Steuerberatungskosten',
        direction: 'expense',
        e1aKz: '9230',
        defaultTaxCode: 'vst-20',
    },
    {
        code: '7710',
        name: 'Betriebliche Versicherungen',
        direction: 'expense',
        e1aKz: '9230',
        defaultTaxCode: 'vst-0',
    },
    {
        code: '7720',
        name: 'Beiträge und Gebühren (WKO, Kammer)',
        direction: 'expense',
        e1aKz: '9230',
        defaultTaxCode: 'vst-0',
    },
    {
        code: '7730',
        name: 'Porto und Versandkosten',
        direction: 'expense',
        e1aKz: '9230',
        defaultTaxCode: 'vst-20',
    },
    {
        code: '7900',
        name: 'Sonstige Betriebsausgaben',
        direction: 'expense',
        e1aKz: '9230',
        defaultTaxCode: 'vst-20',
        // Der Sammeltopf: hier landet der Laptop, wenn niemand die richtige
        // Kategorie gewählt hat.
        capitalisable: true,
    },
    // --- Anlagevermögen -------------------------------------------------------
    {
        code: '0400',
        name: 'Anlagenzugang Betriebs- und Geschäftsausstattung',
        direction: 'asset',
        e1aKz: null,
        defaultTaxCode: 'vst-20',
        isAsset: true,
        description: 'Erzeugt automatisch einen Eintrag im Anlagenverzeichnis.',
    },
    {
        code: '0630',
        name: 'Anlagenzugang IT-Hardware',
        direction: 'asset',
        e1aKz: null,
        defaultTaxCode: 'vst-20',
        isAsset: true,
    },
    {
        code: '0640',
        name: 'Anlagenzugang Software und Lizenzen',
        direction: 'asset',
        e1aKz: null,
        defaultTaxCode: 'vst-20',
        isAsset: true,
    },
    {
        code: '0650',
        name: 'Anlagenzugang Fahrzeuge',
        direction: 'asset',
        e1aKz: null,
        defaultTaxCode: 'vst-none',
        isAsset: true,
    },
    // --- Privat und durchlaufende Posten --------------------------------------
    {
        code: '9600',
        name: 'Privatentnahme',
        direction: 'private',
        e1aKz: null,
        defaultTaxCode: 'purchase-private',
    },
    {
        code: '9610',
        name: 'Privateinlage',
        direction: 'private',
        e1aKz: null,
        defaultTaxCode: 'purchase-private',
    },
    {
        code: '3500',
        name: 'Umsatzsteuer-Zahlung an das Finanzamt',
        direction: 'neutral',
        e1aKz: null,
        defaultTaxCode: 'purchase-private',
        description: 'Durchlaufender Posten — kein Einfluss auf den Gewinn.',
    },
    {
        code: '9620',
        name: 'Einkommensteuer-Vorauszahlung',
        direction: 'private',
        e1aKz: null,
        defaultTaxCode: 'purchase-private',
        description: 'Privatentnahme, keine Betriebsausgabe.',
    },
    {
        code: '2800',
        name: 'Umbuchung zwischen eigenen Konten',
        direction: 'neutral',
        e1aKz: null,
        defaultTaxCode: 'purchase-private',
    },
];
/**
 * Kategorien, auf denen eine Anschaffung landen kann, die eigentlich ein
 * Wirtschaftsgut ist. Nur sie bekommen den § 13-Hinweis — bei Beratung, Miete,
 * Versicherung oder Reisekosten wäre er immer falsch.
 *
 * Selbst angelegte Kategorien stehen hier nicht und lösen den Hinweis daher
 * nicht aus. Das ist Absicht: ein falscher Hinweis kostet mehr Vertrauen als
 * ein fehlender.
 */
export const CAPITALISABLE_CATEGORY_CODES = AT_DEFAULT_CATEGORIES.filter((category) => category.capitalisable).map((category) => category.code);
export function isCapitalisableCategory(code) {
    return code !== null && code !== undefined && CAPITALISABLE_CATEGORY_CODES.includes(code);
}
/**
 * Kategorien, deren Beträge die Luxustangente eines zu teuren PKW mitkürzt
 * (§ 20 Abs 1 Z 2 lit b EStG). Die Kürzung greift nur, wenn genau ein
 * betroffenes Fahrzeug im Anlagenverzeichnis steht — sonst weiß niemand,
 * welches Auto gemeint ist, und die Buchhaltung fragt nach.
 */
export const VALUE_DEPENDENT_VEHICLE_CATEGORY_CODES = AT_DEFAULT_CATEGORIES.filter((category) => category.vehicleCost === 'value_dependent').map((category) => category.code);
export function isValueDependentVehicleCategory(code) {
    return (code !== null &&
        code !== undefined &&
        VALUE_DEPENDENT_VEHICLE_CATEGORY_CODES.includes(code));
}
/** Codes the posting engine relies on; they may be renamed but not deleted. */
export const SYSTEM_CATEGORY_CODES = [
    '7000', // AfA
    '7010', // GWG
    '7820', // Buchwert Abgang
    '4600', // Anlagenverkauf
    '3500', // USt-Zahlung
    '9600',
    '9610',
    '2800',
];
//# sourceMappingURL=categories.js.map